export default __webpack_public_path__ + "static/media/triangle.48aed8d6.svg";